import React, { useState } from 'react';
import AdminAppBody from '../../../components/admin/AdminAppBody';

const AddStudent = () => {
  const [mode, setMode] = useState('manual'); // 'manual' or 'excel'
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    applyFor: '',
    interested: '',
    date: '',
  });
  const [excelFile, setExcelFile] = useState(null);

  const handleModeChange = (e) => {
    setMode(e.target.value);
    setFormData({
      name: '',
      mobile: '',
      email: '',
      applyFor: '',
      interested: '',
      date: '',
    });
    setExcelFile(null);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert('Student added:\n' + JSON.stringify(formData, null, 2));
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    setExcelFile(file);
    alert(`Selected Excel file: ${file.name}`);
  };

  const downloadTemplate = () => {
    const headers = ["Name", "Mobile No", "Email", "Apply For", "Interested", "Date"];
    const rows = [
      ["John Doe", "9876543210", "john@example.com", "BBA", "Marketing", "2025-06-01"],
      ["Jane Smith", "9123456789", "jane@example.com", "BCA", "Web Development", "2025-06-02"],
    ];

    let csvContent = headers.join(",") + "\n";
    rows.forEach(row => {
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "student_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AdminAppBody
      content={
        <div className="container card mt-4">
          <h2 className="mb-4">Add Student</h2>

          <div className="mb-4">
             <h6 className='text-bold'>Choose options</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                id="manualAdd"
                value="manual"
                checked={mode === 'manual'}
                onChange={handleModeChange}
              />
             
              <label className="form-check-label" htmlFor="manualAdd">
                Manually Add Student
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                id="excelAdd"
                value="excel"
                checked={mode === 'excel'}
                onChange={handleModeChange}
              />
              <label className="form-check-label" htmlFor="excelAdd">
                Add Excel List
              </label>
            </div>
          </div>

          {mode === 'manual' && (
            <form onSubmit={handleFormSubmit}>
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Mobile No</label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-control"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Apply For</label>
                  <input
                    type="text"
                    name="applyFor"
                    className="form-control"
                    value={formData.applyFor}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Interested</label>
                  <input
                    type="text"
                    name="interested"
                    className="form-control"
                    value={formData.interested}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary">
                Add Student
              </button>
            </form>
          )}

{mode === 'excel' && (
  <div className="col-12">
    <div className="row align-items-center mb-3">
      <div className=" col-12 d-flex align-items-center gap-2">
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          className="form-control"
          onChange={handleExcelUpload}
        />
       <button
  className="btn btn-secondary btn-lg text-center"
  onClick={downloadTemplate}
  type="button"
>Download Template
</button>

      </div>
    </div>

    {excelFile && (
      <div className="row">
        <div className="col-12 d-flex align-items-center gap-3">
          <small className="text-muted">Selected file: {excelFile.name}</small>
          <button
            className="btn btn-primary ms-auto mt-2 mb-2"
            onClick={() => alert(`Adding students from ${excelFile.name}`)}
            type="button"
          >
            Add Excel Students
          </button>
        </div>
      </div>
    )}
  </div>
)}


        </div>
      }
    />
  );
};

export default AddStudent;
